module.exports = __webpack_public_path__ + "img/reportforrepair1.c05f2cf7.png";